import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-pano-uretim',
  standalone: true,
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: '<router-outlet></router-outlet>',
  styles: [`:host { display: flex; flex-direction: column; flex: 1; min-height: 0; min-width: 0; }`],
})
export class HmiPanoUretimComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }
}
